export const Screens = {
  BoardMembersScreen: 0,
  BoardProfileCard: 1,
  AddMemberToWorkspace: 2,
} as const;
